import { Box, Typography } from "@mui/material";
import {
  Color,
  CornerRadius,
  Gradients,
  PolicyCard,
} from "@axismaxlife/unified-ui-components-library";
import { String } from "../../constants/Strings";
import { fonts } from "../../style/fonts/fonts";

const COPY = String.CurrentPortfolio;

const Detail = ({ label, value }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography
      sx={{
        fontSize: "10px",
        fontFamily: fonts.notoSans,
        fontWeight: 500,
        lineHeight: 1.3,
        color: Color.Text.Secondary,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        mt: "4px",
        fontSize: "13px",
        fontFamily: fonts.notoSans,
        fontWeight: 700,
        lineHeight: 1.3,
        color: Color.Text.Default,
      }}
    >
      {value}
    </Typography>
  </Box>
);

export const PortfolioPolicyCard = ({
  planName,
  policyNumber,
  insuredName,
  sumAssured,
  premiumAmount,
  policyTerm,
  inceptionDate,
  totalPremiumPaid,
  labels,
}) => (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      px: "20px",
      py: "24px",
      borderRadius: `${CornerRadius[16]}px`,
      border: `1px solid ${Color.Border.MB100}`,
      background: Gradients.Secondary.Metal,
    }}
  >
    <PolicyCard
      className="acr-portfolio-policy-card"
      variant="neutral"
      width="100%"
      hasFooter={false}
      showArrowIcon={false}
      showInfoIcon={false}
      badgeText={COPY.planName}
      policyNumber={policyNumber}
      policyHolderName={`${planName} (${policyNumber})`}
      insuredName={insuredName}
      sumAssured={sumAssured}
      premiumAmount={premiumAmount}
      premiumDueOn={policyTerm}
    />

    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        mt: "24px",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        columnGap: "12px",
      }}
    >
      <Detail label={labels.inceptionDate} value={inceptionDate} />
      <Box sx={{ gridColumn: "span 2", minWidth: 0 }}>
        <Detail label={labels.totalPremiumPaid} value={totalPremiumPaid} />
      </Box>
    </Box>
  </Box>
);
